import { selfAxios } from "../../../../axios/selfAxios.js";
async function opPostGetShopManageRightByConditionV2(params) {
  const res = await selfAxios.post(`/designordercenter/productionOrderMarketConfig/getShopManageRightByConditionV2`, params, { _cache: true });
  return res.data;
}
export { opPostGetShopManageRightByConditionV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/productionOrderMarketConfig/getShopManageRightByConditionV2/post.js